import styled from 'styled-components';
import React from 'react';
import {
  EfficiencyData,
  EfficiencyTranslations,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {EfficiencyLayerButton} from './efficiency-layer';
import {EmissionConsumptionDefinitionList} from './emission-consumption-definition-list';
import {useComponent} from '../component-library';

const VerticalSpacer = styled.div`
  margin-top: ${(props) => props.theme.internal.size.static100};
`;

export interface ModelEfficiencyDataProps {
  readonly efficiencyData: EfficiencyData;
  readonly efficiencyTranslations: EfficiencyTranslations;
  readonly disclaimerReferenceLabelTranslation: string | undefined;
  readonly modelName: string;
  readonly closeButtonLabel: string;
  readonly includeDisclaimerInEfficiencyLayer: boolean;
  readonly isEfficiencyClassMandatory?: boolean;
}

export function ModelEfficiencyData({
  efficiencyData,
  efficiencyTranslations,
  disclaimerReferenceLabelTranslation,
  modelName,
  closeButtonLabel,
  includeDisclaimerInEfficiencyLayer,
  isEfficiencyClassMandatory,
}: ModelEfficiencyDataProps): JSX.Element | null {
  const Text = useComponent('Text');
  const {
    consumptionsInlineDisclaimer,
    emissionsInlineDisclaimer,
    electricRangeInlineDisclaimer,
    showAllValuesButtonLabel,
  } = efficiencyTranslations;
  if (efficiencyData.combinedEfficiencyData.isRequiredEfficiencyDataMissing) {
    return null;
  }

  return (
    <VerticalSpacer>
      <EmissionConsumptionDefinitionList
        efficiencyData={efficiencyData}
        efficiencyTranslations={efficiencyTranslations}
        disclaimerReferenceLabelTranslation={
          disclaimerReferenceLabelTranslation
        }
        closeButtonLabel={closeButtonLabel}
        isEfficiencyClassMandatory={isEfficiencyClassMandatory}
      />
      {consumptionsInlineDisclaimer && (
        <Text tag="p" variant="copy-medium">
          {consumptionsInlineDisclaimer}
        </Text>
      )}
      {emissionsInlineDisclaimer && (
        <Text tag="p" variant="copy-medium">
          {emissionsInlineDisclaimer}
        </Text>
      )}
      {electricRangeInlineDisclaimer && (
        <Text tag="p" variant="copy-medium">
          {electricRangeInlineDisclaimer}
        </Text>
      )}
      {showAllValuesButtonLabel?.trim() && (
        <EfficiencyLayerButton
          modelName={modelName}
          efficiencyData={efficiencyData}
          efficiencyTranslations={efficiencyTranslations}
          disclaimerReferenceLabelTranslation={
            disclaimerReferenceLabelTranslation
          }
          closeButtonLabel={closeButtonLabel}
          includeDisclaimerInEfficiencyLayer={
            includeDisclaimerInEfficiencyLayer
          }
        />
      )}
    </VerticalSpacer>
  );
}
